import { createSlice } from '@reduxjs/toolkit';
import { ICompany } from '../../../auth/interfaces/ICompany';
import { CompanyReducer } from '../../reducers/CompanyReducer';

const initialState: ICompany = {
	legal_name: null,
	user_kam: null,
};

export const companySlice = createSlice({
	name: 'company',
	initialState,
	reducers: CompanyReducer,
});

export const { setCompany, setPaymentEmail } = companySlice.actions;

export default companySlice.reducer;
